import type { IntakeProgressInputs } from './types';

/** Calculate intake completion from value-free facts, scoped to one provider. */
export function deriveIntakeProgress(
  inputs: IntakeProgressInputs | null | undefined,
): { percentComplete: number; complete: boolean } | undefined {
  if (!inputs) return undefined;
  const pages = inputs.pages;
  const valuesComplete = (page: IntakeProgressInputs['pages'][number]): boolean =>
    page.acknowledged && page.required_values_present.every(Boolean);
  return summarizeIntakePages(
    pages.map(page => {
      if (!valuesComplete(page)) return false;
      if (!page.is_review) return true;
      const dependencies = pages.filter(
        other => other.section === page.section && !other.is_review,
      );
      return dependencies.length > 0 && dependencies.every(valuesComplete);
    }),
  );
}

/** Count completed pages identically for reconciled local fields and roster facts. */
export function summarizeIntakePages(pages: boolean[]): {
  percentComplete: number;
  complete: boolean;
} {
  const completeCount = pages.filter(Boolean).length;
  return {
    percentComplete: pages.length ? Math.round((completeCount / pages.length) * 100) : 0,
    complete: pages.length > 0 && completeCount === pages.length,
  };
}
